<template><!-- svgo-optimised -->
<svg class="icon icon__plus icon icon__plus" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14 8a.5.5 0 0 1-.5.5h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 1 1 0-1h5v-5a.5.5 0 1 1 1 0v5h5a.5.5 0 0 1 .5.5Z"/></svg>
</template>